module.exports = __webpack_public_path__ + "static/media/2.d22c8a9a.jpg";